import retryCallIfNeeded from '../../../restCalls';

export default function calculatorSummaryService(client) {
  const postCalculatorSummary = async payload => retryCallIfNeeded(
    client,
    () => client.post('/api/financialplan/v1/summary', payload),
  );

  return {
    postCalculatorSummary,
  };
}
